import ContentCopy from "@mui/icons-material/ContentCopy";
import ButtonGroup from "@mui/material/ButtonGroup";
import IconButton from "@mui/material/IconButton";
import Paper, { PaperProps } from "@mui/material/Paper";
import classNames from "classnames";
import React, { useState } from "react";
import Markdown from "react-markdown";
import { FeedbackThumbs, Message } from "../../interfaces/sirius";
import ChatProfile from "./ChatProfile";
import MessageFeedbackButton from "./MessageFeedbackButton";
interface MessageBubbleProps extends PaperProps {
  message: Message;
  isLatestMessage: boolean;
  handleFeedback: Function;
  withActions?: boolean;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({
  message,
  isLatestMessage,
  handleFeedback,
  withActions = true,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);
  const handleCopyMessage = async (contenu: string) => {
    try {
      await navigator.clipboard.writeText(contenu);
    } catch (err) {
      console.error("Erreur lors de la copie dans le presse-papiers : ", err);
    }
  };

  const isChatbot = message.type === "ai";

  function Link(props: any) {
    return (
      <a href={props.href} target="_blank" rel="noreferrer">
        {props.children}
      </a>
    );
  }

  return (
    <div
      className={classNames("flex w-full", {
        "justify-end": !isChatbot,
        "justify-start gap-4 md:gap-5 lg:gap-6": isChatbot,
      })}
    >
      {isChatbot && <ChatProfile />}
      <Paper
        elevation={0}
        className={classNames("flex flex-col", {
          "rounded-2xl py-2.5 px-5 bg-gray-200 max-w-[70%]": !isChatbot,
        })}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Markdown components={{ a: Link }}>{message.content}</Markdown>
        {isChatbot && (
          <ButtonGroup
            className={classNames("flex items-center w-full", {
              visible: isHovered || isLatestMessage,
              invisible: !isHovered && !isLatestMessage,
            })}
          >
            <IconButton onClick={() => handleCopyMessage(message.content)}>
              <ContentCopy className="w-4 h-4" />
            </IconButton>
            {withActions && (
              <>
                <MessageFeedbackButton
                  message={message}
                  handleFeedback={handleFeedback}
                  thumbIconMode={FeedbackThumbs.THUMBS_UP}
                  iconClassName="w-4 h-4"
                />
                <MessageFeedbackButton
                  message={message}
                  handleFeedback={handleFeedback}
                  thumbIconMode={FeedbackThumbs.THUMBS_DOWN}
                  iconClassName="w-4 h-4"
                />
              </>
            )}
          </ButtonGroup>
        )}
      </Paper>
    </div>
  );
};

export default MessageBubble;
